function mergeInternal(source: any, target: any): void {
	let keys = Object.keys(source);
	let i = -1;
	let l = keys.length;
	while (++i < l) {
		let key = keys[i];
		let sourceItem = source[key];
		let targetItem = target[key];
		//Prevent never-ending loop
		if (target === sourceItem) {
			continue;
		}

		const isArray = Array.isArray(sourceItem);

		if (sourceItem !== null && (isArray || typeof sourceItem === "object")) {
			if (targetItem == null) {
				if ("clone" in sourceItem && typeof sourceItem.clone === "function") {
					target[key] = sourceItem.clone();
					continue;
				}

				target[key] = targetItem = isArray ? [] : {};

			} else if (isArray) {
				//an array the target already has is an override, never merged element-wise
				//(defaults [500,502] must not leak into a request's [404])
				continue;
			}

			mergeInternal(sourceItem, targetItem);

		} else if (targetItem == null) {
			target[key] = sourceItem;
		}
	}
}

/**
 * Escribe sobre target lo que venga en defaults, solo si en target no existe la propiedad a escribir.
 * @param defaults - Los defaults a mergear.
 * @param target - El objeto destino sobre el cual se mergearán los valores.
 * @returns El objeto destino.
 */
export default function mergeObjects<T>(defaults: T | null, target: T | null): T {
	//@ts-ignore
	target ??= {};
	if (defaults == null) {
		return target!;
	}
	mergeInternal(defaults, target);
	return target!;
};
